import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { article as articleData } from "shared/data/article";

import { getArticleType } from "scmp-app/components/article/article-render/helpers";
import { usePlusArticlePopup } from "scmp-app/components/plus/article-popup/hooks";
import type { contentPlusNewsAgendaRightContentContent$key } from "scmp-app/queries/__generated__/contentPlusNewsAgendaRightContentContent.graphql";

import {
  StyledContentItemPlusOpinion,
  StyledContentItemPlusPrimary,
  StyledContentItemPlusSecondary,
} from "./styles";

export type Props = {
  reference: contentPlusNewsAgendaRightContentContent$key;
};

export const PlusNewsAgendaRightContent: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const article = useFragment(
    graphql`
      fragment contentPlusNewsAgendaRightContentContent on Content {
        entityId
        ...helpersGetArticleTypeArticle
        ...hooksPlusArticleLinkHandlerArticle
        ...plusOpinionContentItemContent
        ...plusPrimaryContentItemContent
        ...plusSecondaryContentItemContent
      }
    `,
    reference_,
  );

  const { handleOpen } = usePlusArticlePopup();
  const articleTypeId = getArticleType(article) ?? "";

  switch (articleTypeId) {
    case articleData.types.betweenTheLines.entityId:
    case articleData.types.chinaFutureTechBriefing.entityId:
    case articleData.types.factSheet.entityId:
    case articleData.types.infographic.entityId:
      return (
        <StyledContentItemPlusPrimary
          onClick={() => handleOpen(article, { pageType: "agenda", widgetName: "related_content" })}
          reference={article}
        />
      );
    case articleData.types.column.entityId:
    case articleData.types.opinion.entityId:
      return (
        <StyledContentItemPlusOpinion
          onClick={() => handleOpen(article, { pageType: "agenda", widgetName: "related_content" })}
          reference={article}
          withAuthor
        />
      );
    default:
      return (
        <StyledContentItemPlusSecondary
          onClick={() => handleOpen(article, { pageType: "agenda", widgetName: "related_content" })}
          reference={article}
        />
      );
  }
};

PlusNewsAgendaRightContent.displayName = "PlusNewsAgendaRightContent";
